import { render, staticRenderFns } from "./ToggleComponent.vue?vue&type=template&id=fc1b4fa0&scoped=true"
import script from "./ToggleComponent.vue?vue&type=script&lang=js"
export * from "./ToggleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1b4fa0",
  null
  
)

export default component.exports